//平台、设备和操作系统
var system = {
    win: false,
    mac: false,
    xll: false
};
//检测平台
var p = navigator.platform;
system.win = p.indexOf("Win") == 0;
system.mac = p.indexOf("Mac") == 0;
system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
//跳转语句
if (system.win || system.mac || system.xll) {//pc
    window.$isApp = false;
} else {//手机
    window.$isApp = true;
}

// 设置App对接方式
window.setupWebViewJavascriptBridge = function(callback) {
    if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)

    //callback && callback('web');
}

//IOSAndroid
//获取APP类型
window.appType = '';
//获取APP版本
window.appVersion = '';
//安卓获取
if(typeof APP != 'undefined'){
    window.appType = APP.getAppType();
    window.appVersion = APP.getAppVersion();
}

window.getAppType = function(val){
    //$('body').append('<p>getAppType：' + val + '</p>');
    window.appType = val;
}
window.getAppVersion = function(val){
    //$('body').append('<p>getAppVersion：' + val + '</p>');
    window.appVersion = val;
}


//设置app头部背景
window.setStatusBarBgColor = function(val){
    //IOS
    window.setupWebViewJavascriptBridge(function (bridge) {
        //APP设置顶部背景色
        bridge.callHandler('APP.SetStatusBarBgColor', {'topBgColor': val}, function responseCallback(responseData) {

        })
    })

    //Android
    if(window.appType == 'Android') {
        APP && APP.SetStatusBarBgColor(JSON.stringify({'topBgColor': val}))
    }
}

window.setStatusBarBgColor('#E36159');


//APP主动推送消息
/**
 *
 * @param opts = {
 *  "content_type": "BJ", //报价
 *  "message_type": "MSG_TYPE_BJ",
 *  "url": "https://www.aaa",
 *  "title": "推送消息文字"
 * }
 *
 */
window.appPushMessage = function(opts){

}



//拨打电话
/*window.makeCall = function(tel){
    //浏览器web
    if(!window.appType){
        window.location.href = 'tel:' + tel;
        return;
    }

    //IOS
    window.setupWebViewJavascriptBridge(function (bridge) {
        //IOS打电话
        bridge.callHandler('APP.makeCall', {'tel': tel});
    })

    //Android
    APP && APP.makeCall({'tel': tel})
}*/


/*//APP返回上一级页面
//nextUrl--url地址
//pageStatus--appear(已存在页面)--disAppear(新打开页面)
//fun--执行函数名
window.setupWebViewJavascriptBridge(function (bridge) {
    bridge.callHandler('APP.ClosePage', {'nextUrl': '', 'pageStatus': 'appear', 'fun': 'pageDisAppear("aa", "bb")'}, function responseCallback(responseData) {
        $('body').append('APP设置顶部背景色')
    })
})*/



//默认打开
window.PageAppear = function(url){

}
//默认关闭
window.PageDisAppear = function(url){

}




/*setupWebViewJavascriptBridge(function(bridge) {

    /!* Initialize your app here *!/

    /!*bridge.registerHandler('JS Echo', function(data, responseCallback) {
        console.log("JS Echo called with:", data)
        responseCallback(data)
    })*!/
    bridge.callHandler('APP.UrlCommon', {'key':'value'}, function responseCallback(responseData) {
        console.log("JS received response:", responseData)
    })
})*/



// WEBPACK FOOTER //
// ./src/common/js/all.js